<template>
  <div class="main">
    <div class="bg_container">
      <div class="logo_wrap">
        <img class="logo_cont" src="../assets/imgCata/logo.png" />
      </div>
      <div class="content_wrap">
        <div class="content_cont">
          <!-- 提示 -->
          <div class="tips bigBold">Please fill in the information to</div>
          <div class="tips margin-bottoml bigBold">download our catalog</div>
          <!-- 公司名称 -->
          <div class="labal">Company Name：</div>
          <div class="input_wrap">
            <input class="form_input Required" type="text" v-model="name" />
          </div>
          <!-- email地址 -->
          <div class="labal">Email Address：</div>
          <div class="input_wrap">
            <input class="form_input Required" type="text" v-model="address" />
          </div>
          <!-- 联系人 -->
          <div class="labal">Contect No./Person：</div>
          <div class="input_wrap">
            <input class="form_input Required" type="text" v-model="person" />
          </div>

          <!-- 提交按鈕 -->
          <div class="btn_wrap" @click="submit">Submit</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      address: "",
      person: "",
    };
  },
  methods: {
    submit() {
      var ajaxData = new FormData();
      var data = [
        {
          title: "Company Name",
          value: this.name,
        },
        { title: "Email Address", value: this.address },
        { title: "Contect No./Person", value: this.person },
      ];
      ajaxData.append("content", JSON.stringify(data));
      this.$axios({
        method: "POST",
        url: "/api/collect/",
        headers: {
          Authorization:
            this.$localStorage.token_type + this.$localStorage.token,
        },
        data: ajaxData,
      })
        .then((res) => {
          console.log(res);
          this.$router.push("/DownLoadpdf");
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: siYuanBold;
  src: url('../assets/text/Roboto-Bold.ttf');
}
.bigBold {
  font-family: "siYuanBold";
}
.bg_container {
  width: 100%;
  height: 100vh;
  background: url("../assets/imgCata/background.png");
  background-size: 100% auto;
}
.content_wrap {
  background: url("../assets/imgCata/content.png") no-repeat;
  background-size: 100% 100%;
  height: 80vh;
  width: 84%;
  margin: 0 auto;
  /* border: 1px solid olive; */
}
.tips{
  text-align: center;
  font-size: 21px;
  line-height: 30px;
  color: black;
}
.margin-bottoml{
  margin-bottom: 40px;
}
.content_cont {
  /* border: 1px solid red; */
  padding-top: 30%;
  width: 84%;
  margin: 0 auto;
  overflow: hidden;
}
@media screen and (min-width: 410px) and (max-width: 414px) {
  .content_cont {
    padding-top: 16% !important;
  }
  .btn_wrap{
    margin-top: 26%!important;
  }
}

.labal {
  font-size: 21px;
  margin-top: 16px;
  color: black;
}
.btn_wrap {
  border: 1px solid #42aeee;
  background: #42aeee;
  margin-top: 30%;
  font-size: 20px;
  float: right;
  color: white;
  padding: 6px 16px;
  border-radius: 12px;
}
.input_wrap {
  /* border-bottom: 1px solid #000; */
}
.form_input {
  width: 100%;
}
.logo_wrap {
  /* border: 1px solid red; */

  width: 30%;
  margin-left: 9%;
  padding-top: 5vh;
}
.logo_cont {
  width: 100%;
  object-fit: cover;
  /* border: 1px solid green; */
}
input {
  outline: none;
  font-size: 18px;
  border: none;
  border-bottom: 1px solid #000;
  border-radius: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Catalogue.vue